import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-218797c0")
const _hoisted_1 = { class: "p-d-flex p-jc-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user p-mr-3" })
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!

  return (_openBlock(), _createBlock(_component_FloatLabel, { label: _ctx.label }, {
    default: _withCtx(() => [
      _createVNode(_component_AutoComplete, _mergeProps(_ctx.$attrs, {
        dropdown: _ctx.showDropdown || false,
        completeOnFocus: "",
        modelValue: _ctx.searchBox,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchBox = $event)),
        suggestions: _ctx.suggestions,
        field: 'business_name',
        minLength: 2,
        label: _ctx.label,
        onItemSelect: _ctx.onSelect,
        onComplete: _ctx.search,
        onChange: _ctx.onChange
      }), {
        item: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createElementVNode("span", null, _toDisplayString(item.business_name), 1)
            ])
          ])
        ]),
        _: 1
      }, 16, ["dropdown", "modelValue", "suggestions", "label", "onItemSelect", "onComplete", "onChange"]),
      (!_ctx.showDropdown)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            disabled: _ctx.$attrs.disabled,
            icon: "pi pi-times",
            onClick: _ctx.onClear
          }, null, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["label"]))
}